import { IconProps } from 'foundations-assets/icons/icon.types';
import { UIModeMap, UIMode } from 'framework-listing-lib/types';
import { ComponentType } from 'react';

import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { GridIcon } from 'foundations-assets/icons/components/GridIcon';
import { ListViewIcon } from 'foundations-assets/icons/components/ListViewIcon';

export const UI_MODE: UIModeMap = {
  FOLDERS: 'FOLDERS',
  GALLERY: 'GALLERY',
  LIST: 'LIST',
  CALENDAR: 'CALENDAR',
};

/**
 * Trellis-compliant map of UI mode string to an icon component.
 */
export const UI_MODE_ICON: Record<UIMode, ComponentType<IconProps>> = {
  FOLDERS: FolderIcon,
  GALLERY: GridIcon,
  LIST: ListViewIcon,
  CALENDAR: DateIcon,
};

export const UI_MODE_COPY: Record<UIMode, string> = {
  FOLDERS: 'frameworkListingLib.uiModes.FOLDERS',
  GALLERY: 'frameworkListingLib.uiModes.GALLERY',
  LIST: 'frameworkListingLib.uiModes.LIST',
  CALENDAR: 'frameworkListingLib.uiModes.CALENDAR',
};
